<template>
  <div class="room-interpreting-interpreter-component">
    <div class="room-interpreting-interpreter">
      <div class="interpreting interpreter">
        <div class="interpreting-header">
          <div class="interpreting-title-container">
            <p class="interpreting-title">{{ $t("interpret.lang.title") }}</p>
            <span class="interpreting-status enable">{{ $t("common.active") }}</span>
            <span class="interpreting-status disable">{{ $t("common.deactive") }}</span>
          </div>
          <button class="interpreting-close-button" @click="onClose"></button>
        </div>
        <div class="interpreting-body">
          <div class="interpreting-add-language">
            <form @submit.prevent="onAddLanguage">
              <input class="interpreting-add-language-input" :placeholder="$t('interpret.lang.add.placeholder')" v-model="language" />
              <button class="interpreting-add-language-toggle-button">{{ $t("interpret.lang.add.title") }}</button>
            </form>
          </div>
          <div class="interpreting-language-list-wrapper">
            <ul class="interpreting-language-list">
              <li v-for="(language, i) in languageList" :key="i" class="interpreting-language-item">
                <p class="interpreting-language-title">{{ language }}</p>
                <div class="interpreting-language-button-container">
                  <div class="interpreting-set-interpreter">
                    <button class="interpreting-set-interpreter-button" @click="onToggleInterpreterModal(language)">{{ $t("interpret.interpreter") }}</button>
                    <GrmMenu
                      class="interpreter-modal"
                      :open.sync="isShowInterpreterModal[language]"
                      :list="interpreterList(language)"
                      @click="item => onSelectInterpreter(language, item)"
                    />
                  </div>
                  <button class="interpreting-remove-interpreter-button" @click="onRemoveLanguage(language)">{{ $t("common.delete") }}</button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import GrmMenu from '@/components/Common/menu/GrmMenu'
import Vue from "vue";

export default {
  name: 'RoomInterpretingInterpreter',
  components: {
    GrmMenu
  },
  data() {
    return {
      language: '',
      languageList: [],
      isShowInterpreterModal: {},
      selectedInterpreter: {},
    }
  },
  computed: {
    ...mapGetters('user', [
        'getUsername',
        'roomUserList',
    ]),
    interpreterList() {
      return language => {
        const list = []
        this.roomUserList.forEach(roomUser => {
          list.push({
            value: roomUser,
            title: this.getUsername(roomUser),
            selected: () => {
              return this.selectedInterpreter[language]
            },
            click: (e, item) => {
              const roomUser = item.value
              this.onSelectInterpreter(language, roomUser)
            }
          })
        })
        return list
      }
    }
  },
  methods: {
    onAddLanguage() {
      if (!this.language.trim()) {
        return
      }

      if (this.languageList.indexOf(this.language.trim()) > -1) {
        this.$alert(this.$t('interpret.lang.add.exist'))
        return
      }

      try {
        // Room.addInterpretingLanguage(this.language);

        this.languageList.push(this.language)
      } catch(e) {
        console.error(e)
        this.$alert(this.$t('interpret.lang.add.fail'))
      } finally {
        this.language = ''
      }
    },
    onRemoveLanguage(language) {
      this.$alert({
        title: this.$t('interpret.lang.delete.title'),
        text: this.$t('interpret.lang.delete.confirm'),
        ok: () => {
          try {
            // Room.removeInterpretingLanguage(language)

            this.languageList = this.languageList.filter(l => l !== language)
          } catch(e) {
            console.error(e)
            this.$alert(this.$t('interpret.lang.delete.fail'))
          }
        }
      });
    },
    onToggleInterpreterModal(language) {
      this.isShowInterpreterModal[language] === undefined
          ? Vue.set(this.isShowInterpreterModal, language, true)
          : this.isShowInterpreterModal[language] = !this.isShowInterpreterModal[language]
    },
    onSelectInterpreter(language, roomUser) {
      if (this.selectedInterpreter[language] === roomUser.userId) {
        this.selectedInterpreter[language] = ''
      } else {
        this.selectedInterpreter[language] = roomUser.userId
      }
    },
    onClose() {
      this.$modal('RoomInterpretingModal')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/roomType/conf/css/_interpreting';
.room-interpreting-interpreter-component {}
.room-interpreting-interpreter {}

// component
.interpreter-modal {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
}
</style>